import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
dayjs.extend(customParseFormat);
// Define the required format
const BOOKING_DATE_FORMAT = "YYYY-MM-DD";
export const isValidBookingDate = (value) => {
    // Check 1: Ensure the input is a string
    if (typeof value !== "string") {
        return false;
    }
    // Check 2: Attempt to parse the string using the specific format
    // The 'true' argument activates STRICT parsing, meaning the input
    // must match the format exactly.
    const dateObject = dayjs(value, BOOKING_DATE_FORMAT, true);
    // Check 3: Verify that the resulting Day.js object is valid
    return dateObject.isValid();
};
//# sourceMappingURL=booking.js.map